const dataModelsActions = {
  FETCH_DATA_MODELS: 'FETCH_DATA_MODELS',
  FETCH_DATA_MODELS_ERROR: 'FETCH_DATA_MODELS_ERROR',
  FETCH_DATA_MODELS_SUCCESS: 'FETCH_DATA_MODELS_SUCCESS',
  FETCH_DATASET_DATA_MODEL: 'FETCH_DATASET_DATA_MODEL',
  FETCH_DATASET_DATA_MODEL_ERROR: 'FETCH_DATASET_DATA_MODEL_ERROR',
  FETCH_DATASET_DATA_MODEL_SUCCESS: 'FETCH_DATASET_DATA_MODEL_SUCCESS',
  UPDATE_DATASET_DATA_MODEL: 'UPDATE_DATASET_DATA_MODEL',
  UPDATE_DATASET_DATA_MODEL_ERROR: 'UPDATE_DATASET_DATA_MODEL_ERROR',
  UPDATE_DATASET_DATA_MODEL_SUCCESS: 'UPDATE_DATASET_DATA_MODEL_SUCCESS',
};

export const hiddenDataModels = ['custom'];

export default dataModelsActions;
